module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Thunder-night-701447074bfe05ac30245fd36baada5d.svg";